module.exports = __webpack_public_path__ + "static/media/playstore.db9b21a1.png";